import {
  Box,
  CircularProgress
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { findLast } from "lodash";
import moment from "moment";
import { FiArrowRight } from "react-icons/fi";
import { LuArrowDown, LuArrowDownUp, LuArrowUp } from "react-icons/lu";
import CustomPagination from "../../../components/Common/CustomPagination";

export default function AllOrdersTable(props) {
  const {
    allOrganizationOrders = [],
    onClickEditQuery = () => { },
    setIsDetailView = () => { },
    searchType = {},
    onChangeSearchType = () => { },
    onClickSubmitSearch = () => { },
    onChangePagination = () => { },
    filters = {},
    onClickClear = () => { },
    onChangeSort = () => { },
    isLoading = false,
    isInitialLoading = false,
    hasFetched = false,
  } = props;
  const sortBy = filters?.sortBy || "";
  const sortOrder = filters?.sortDirection || "";

  const handleSortClick = (sortKey) => {
    let newSortOrder = "asc";
    if (sortBy === sortKey) {
      if (sortOrder === "asc") newSortOrder = "desc";
      else if (sortOrder === "desc") newSortOrder = "";
    }

    if (!newSortOrder) {
      onChangeSort("", "");
    } else {
      onChangeSort(sortKey, newSortOrder);
    }
  };

  const COL = {
    no: { label: "No.", width: 36, align: "center" },
    name: { label: "Cargo Name", width: "18%", minWidth: 140, align: "left", sortable: true, sortKey: "name" },
    route: { label: "Route", width: "24%", minWidth: 170, align: "left" },
    qty: { label: "Qty (MT)", width: "9%", minWidth: 80, align: "right" },
    account: { label: "Account", width: "11%", minWidth: 90, align: "left" },
    createdDate: { label: "Created On", width: "12%", minWidth: 100, align: "left", sortable: true, sortKey: "createdAt" },
    createdBy: { label: "Created By", width: "12%", minWidth: 100, align: "left" },
    actions: { label: "Actions", width: 90, minWidth: 90, align: "center" },
  };


  const thStyle = {
    padding: "5px 6px",
    fontSize: 11,
    fontWeight: 500,
    letterSpacing: "0.02em",
    color: "#334155",
    textTransform: "capitalize",
    borderBottom: "1px solid #cbd5e1",
    whiteSpace: "nowrap",
    background: "#e2e8f0",
  };

  const tdStyle = {
    padding: "0.5px 6px",
    fontSize: 11,
    color: "#1e293b",
    borderBottom: "1px solid #e2e8f0",
    verticalAlign: "middle",
  };

  return (
    <div
      style={{
        marginTop: "0.375rem",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 0,
          border: "1px solid #cbd5e1",
          overflow: "hidden",
          minHeight: (isInitialLoading && !allOrganizationOrders.length) ? "500px" : "auto",
        }}
        className="shadow-sm"
      >
        {filters?.totalPages > filters?.limit && (
          <div style={{
            borderBottom: "1px solid #f1f5f9",
            display: "flex",
            justifyContent: "flex-end",
            padding: "1px"
          }}>
            <CustomPagination
              onChangePagination={onChangePagination}
              filters={filters}
              totalPage={filters?.totalPages}
            />
          </div>
        )}
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ background: "#e2e8f0" }}>
                {Object.values(COL).map((col) => (
                  <th
                    key={col.label}
                    style={{
                      ...thStyle,
                      width: col.width,
                      minWidth: col.minWidth,
                      textAlign: col.align || "left",
                      cursor: col.sortable ? "pointer" : "default",
                    }}
                    onClick={() => col.sortable && handleSortClick(col.sortKey)}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: col.align === "right" ? "flex-end" : col.align === "center" ? "center" : "flex-start",
                        gap: 4
                      }}
                    >
                      {col.label}
                      {col.sortable && (
                        <div style={{ display: "flex", flexDirection: "column", color: sortBy === col.sortKey ? "#0f172a" : "#64748b" }}>
                          {sortBy === col.sortKey && sortOrder === "desc" ? (
                            <LuArrowDown size={13} />
                          ) : sortBy === col.sortKey && sortOrder === "asc" ? (
                            <LuArrowUp size={13} />
                          ) : (
                            <LuArrowDownUp size={13} />
                          )}
                        </div>
                      )}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {isInitialLoading && (!Array.isArray(allOrganizationOrders) || !allOrganizationOrders.length) ? (
                <tr>
                  <td colSpan={8} align="center" style={{ padding: "40px" }}>
                    <Box display="flex" justifyContent="center" alignItems="center" height="440px">
                      {allOrganizationOrders?.length > 0 && <CircularProgress />}
                    </Box>
                  </td>
                </tr>
              ) : Array.isArray(allOrganizationOrders) &&
                allOrganizationOrders.length ? (
                allOrganizationOrders.map((item, index) => {
                  const firstLoadDetails =
                    item.cargoList?.length > 0
                      ? item.cargoList.find(
                        (itemDetail) => itemDetail.operation === "Loading"
                      )
                      : {};
                  const lastLoadDetails =
                    item.cargoList?.length > 0
                      ? findLast(item.cargoList, { operation: "Discharging" })
                      : {};
                  return (
                    <tr
                      key={index}
                      onDoubleClick={() => {
                        onClickEditQuery(item);
                        setIsDetailView(true);
                      }}
                      style={{ transition: "background 0.15s", cursor: "pointer", backgroundColor: index % 2 === 1 ? "#f8fafc" : "#ffffff" }}
                      className="hover:bg-slate-100/90 transition-colors"
                    >
                      {/* No */}
                      <td style={{ ...tdStyle, color: "#64748b", fontWeight: 500, textAlign: "center" }}>
                        {(filters.offset - 1) * filters.limit + index + 1}
                      </td>

                      {/* Cargo Name */}
                      <td style={{ ...tdStyle, color: "#1e293b" }}>
                        {item.name || "—"}
                      </td>

                      {/* Route */}
                      <td style={tdStyle}>
                        <div style={{ display: "flex", alignItems: "center", gap: 6, color: "#1e293b" }}>
                          <span style={{ fontWeight: 500 }}>{firstLoadDetails?.port || "—"}</span>
                          <FiArrowRight size={13} color="#94a3b8" />
                          <span style={{ fontWeight: 500 }}>{lastLoadDetails?.port || "—"}</span>
                        </div>
                      </td>

                      {/* Qty */}
                      <td style={{ ...tdStyle, textAlign: "right", fontWeight: 500, color: "#1e293b", fontVariantNumeric: "tabular-nums" }}>
                        {firstLoadDetails?.cargoQty ? Number(firstLoadDetails.cargoQty).toLocaleString() : "—"}
                      </td>

                      {/* Account */}
                      <td style={{ ...tdStyle, color: "#1e293b" }}>
                        {firstLoadDetails?.account || item.account || "—"}
                      </td>

                      {/* Created On */}
                      <td style={{ ...tdStyle, color: "#1e293b", whiteSpace: "nowrap" }}>
                        {item.createdDate
                          ? moment(item.createdDate).format("DD MMM YYYY")
                          : item.createdAt ? moment(item.createdAt).format("DD MMM YYYY") : "—"}
                      </td>

                      {/* Created By */}
                      <td style={{ ...tdStyle, color: "#1e293b" }}>
                        {item.createdUserName || (item.createdUser?.firstName ? `${item.createdUser.firstName} ${item.createdUser.lastName || ""}` : "—")}
                      </td>

                      {/* Action */}
                      <td style={{ ...tdStyle, textAlign: "center", width: 90, minWidth: 90 }}>
                        <button
                          onClick={() => {
                            onClickEditQuery(item);
                            setIsDetailView(true);
                          }}
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 24,
                            height: 24,
                            borderRadius: 4,
                            border: "none",
                            background: "transparent",
                            color: "#1d4ed8",
                            cursor: "pointer",
                          }}
                          title="View Details"
                        >
                          <VisibilityIcon style={{ fontSize: 18 }} />
                        </button>
                      </td>
                    </tr>
                  );
                })
              ) : hasFetched ? (
                <tr>
                  <td colSpan="8" align="center" style={{ padding: "30px", color: "#64748b" }}>
                    No Order Found.
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
        {filters?.totalPages > filters?.limit && (
          <div style={{ borderTop: "1px solid #f1f5f9", display: "flex", justifyContent: "flex-end", padding: "1px" }}>
            <CustomPagination
              onChangePagination={onChangePagination}
              filters={filters}
              totalPage={filters?.totalPages}
            />
          </div>
        )}
      </div>
    </div>
  );
}
